export default __webpack_public_path__ + "img/annie-2.cc252de7.jpeg";